export default (config) => {
    config = {
        ...config,
        productAdd: {
            id: 'ID',
            barcode: 'Barcode'
        },
        paymentType: {
            cash: 'Cash',
            card: 'Card'
        },
        deliveryType: {
            delivery: 'Delivery',
            pickup: 'Pickup'
        },
        bannerPlaces: {
            home: 'Home',
            nav: 'Navigation'
        },
        bannerTypes: {
            slider: 'Slider',
            ltext_slider: 'Left text slider',
            single_banner: 'Single banner',
            double_banner: 'Double banners',
            triple_banner: 'Triple banners',
            video: 'Video and banner',
        },
        subType: {
            default: 'Default',
            newin: 'New arrivals',
            sales: 'Sales',
            designers: 'Designers'
        },
        yesNo: {
            true: 'Yes',
            false: 'No',
        },
        gender: {
            '-': '-',
            m: 'Male',
            f: 'Female'
        },
        status: {
            default: {
                on: 'Active',
                off: 'Not active'
            },
            user: {
                on: 'Active',
                off: 'Hidden',
                pending: 'Pending'
            },
            payment: {
                paid: 'Paid',
                error: 'Error',
                new: 'New'
            },
            store: {
                on: 'Active',
                off: 'Hidden',
                pending: 'Pending',
                expired: 'Expired',
                blocked: 'Blocked'
            },
            order: {
                new: 'New',
                waiting_payment: 'Waiting payment',
                payment_canceled: 'Payment canceled',
                waiting_loyalty: 'Waiting loyalty',
                loyalty_canceled: 'Loyalty canceled',
                ready: 'Ready',
                sent: 'Sent',
                completed: 'Completed',
                canceled: 'Canceled',
                returned: 'Returned',
            },
        },
        feedbackType: {
            info: 'Information',
            comment: 'Suggestion or comment'
        },
        businessType: {
            1: 'I sell the tours that I operate',
            2: 'I sell tours that other companies operate',
            3: 'Both of these apply'
        },
        annualSales: {
            1: 'Not yet started / Less than 1 year of sales',
            2: 'Less than $20,000',
            3: '$20,000 - $100,000',
            4: '$100,000 - $250,000',
            5: '$250,000 - $1M',
            6: '$1M - $4M',
            7: '$4M+',
            8: 'Prefer Not To Say'
        }
    }
    return config
}
